module.exports = __webpack_public_path__ + "d8159b15f7623bfb8b7534e4a43f3d21.svg";